import { RcClasses } from '../../../../foundation';
export var RcSliderClasses = RcClasses(['thumb', 'active', 'trackInverted', 'track', 'focusVisible', 'disabled'], 'RcSlider');
